<template>
  <AppDrawer
    v-model="showEnergyDrawer"
    :has-padding="false"
    @on-close="props.onClose"
    dialog-titel="Energietikett (EU)"
  >
    <div class="border-b-sm border-border-tertiary">
      <div class="p-16 md:p-24">
        <h2 class="heading-xs mb-8">Energietikett (EU)</h2>
      </div>
    </div>
    <section class="max-h-[80dvh] m-16">
      <slot />
    </section>
  </AppDrawer>
</template>

<script setup lang="ts">
interface Props {
  showEnergyDrawerProp: boolean;
  onClose: () => void;
}

const props = defineProps<Props>();

const showEnergyDrawer: Ref<boolean> = ref(false);

watch(
  () => props.showEnergyDrawerProp,
  () => {
    showEnergyDrawer.value = props.showEnergyDrawerProp;
  },
);
</script>
